import Other from './Other';

export default Other;
